import { forwardRef } from 'react';
import { ButtonVariant } from '@shipengine/giger';
import MainForm from './MainForm.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { DisabledFieldsProvider } from '../contexts/disabledFields.js';
import { AddressValuesProvider } from '../contexts/addressValues.js';
import { ContactFormOrientation } from '../types/types.js';

let FieldNames = /*#__PURE__*/function (FieldNames) {
  FieldNames["COMPANYNAME"] = "companyName";
  FieldNames["TAXID"] = "taxId";
  FieldNames["FIRSTNAME"] = "firstName";
  FieldNames["LASTNAME"] = "lastName";
  FieldNames["EMAIL"] = "email";
  FieldNames["PHONE"] = "phone";
  FieldNames["ADDRESS"] = "address";
  FieldNames["COUNTRY"] = "country";
  FieldNames["POSTALCODE"] = "postalCode";
  return FieldNames;
}({});
const DEFAULT_CONFIG = {
  showLegends: false,
  contactFormOrientation: ContactFormOrientation.VERTICAL,
  twoColumns: false
};
const DEFAULT_BUTTON_CONFIG = {
  variant: ButtonVariant.FILLED,
  block: true
};
const DEFAULT_VALIDATION_CONFIG = {
  validateOnBlur: true,
  validateOnChange: true
};
const InvoiceForm = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    config = DEFAULT_CONFIG,
    buttonStyle = DEFAULT_BUTTON_CONFIG,
    validation = DEFAULT_VALIDATION_CONFIG,
    disabledFields,
    ...rest
  } = _ref;
  return jsx(DisabledFieldsProvider, {
    disabledFields: disabledFields,
    children: jsx(AddressValuesProvider, {
      children: jsx(MainForm, {
        config: config,
        buttonStyle: buttonStyle,
        validation: validation,
        ref: ref,
        ...rest
      })
    })
  });
});
InvoiceForm.displayName = 'InvoiceForm';

export { FieldNames, InvoiceForm };
//# sourceMappingURL=InvoiceForm.js.map
